<template>
  <div class="page-wrap">
    <el-row>
      <el-breadcrumb separator="/" class="breadcrumb">
        <el-breadcrumb-item>系统</el-breadcrumb-item>
        <el-breadcrumb-item>菜单管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <div class="page">
      <el-row>
        <section class="content-warpper">
          插件内部版本：
          <el-input v-model="version_kefu" placeholder="请输入版本号" size="small" style="width: 320px;margin: 10px 0px;" @blur="visionChange"></el-input>
          <br>
          插件外部版本：
          <el-input v-model="version_bmc" placeholder="请输入版本号" size="small" style="width: 320px;margin: 0px 0px 20px 0px;" @blur="visionChange"></el-input>
          
          <el-button class="addBtn" size="small" icon="el-icon-plus" @click="newAdd">新增菜单</el-button>
          <treeTable :tableData="allMenuList" :colums="gridColumns">
            <!-- 操作列 -->
            <el-table-column slot="operation" label="操作" width="200px" class-name="operate" fixed="right">
              <template slot-scope="scope">
                <span class="op-btn edit" @click="handleEdit(scope.$index, scope.row)"><i
                    class="el-icon-edit-outline"></i> 编辑</span><span class="verline">|</span>
                <span class="op-btn delete" @click="handleDelete(scope.$index, scope.row)"><i
                    class="el-icon-delete"></i>删除</span>
              </template>
            </el-table-column>
          </treeTable>
        </section>
      </el-row>
      <!-- 新增/编辑弹框 -->
      <newAddModel :modalInfo="addmodelInfo" @reqTableData="reqTableData" />
    </div>
  </div>
</template>
<script>
import treeTable from "components/treeTable";
import newAddModel from "./NewAddModel"; //新增，编辑弹框
import { renderState, renderDialog } from "@/libs/renderCommon";
import { fetchGet, fetchPost } from "@/libs/reqCommon";
import { mapGetters, mapState, mapActions } from 'vuex';
let titles = [
  { title: "菜单名称", key: "menuName", width: 230 },
  { title: "ID", key: "id", width: 130 },
  { title: "菜单别名", key: "menuAlias", width: 200 },
  { title: "菜单图标", key: "menuIcon", width: 300 },
  { title: "前端模块路径", key: "modulename", width: 340 },
  { title: "路由连接", key: "routePath", width: 240 },
  { title: "父级ID", key: "parentid", width: 130 },
  { title: "排序", key: "sortNumber" },
  { title: "状态", key: "menuState", width: 200 },
  { title: "备注", key: "remark", width: 230 }
];
export default {
  components: { treeTable, newAddModel },
  data() {
    return {
      gridColumns: [],
      tableData: [],
      version_kefu: '',
      version_bmc: '',
      addmodelInfo: {},//新增/编辑弹框信息
    };
  },
  computed: {
    ...mapState({
      allMenuList: state => state.menu.allMenuList
    }),
  },
  created() {
    this.initTableColum();
    this.reqAllMenulist();
    this.getVersion();
  },
  methods: {
    ...mapActions(["reqAllMenulist"]),
    // 修改版本号
    visionChange() {
      let params = {
        version_kefu: this.version_kefu,
        version_bmc: this.version_bmc,
      };
      fetch({
        url: "hcm/Index/updateVersion",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.$message({
            message: '修改成功',
            type: 'success'
          });
        }
      })
    },
    // 获取版本号
    getVersion() {
      fetch({
          url: "hcm/Index/getVersion",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.version_kefu = data.version_kefu
            this.version_bmc = data.version_bmc
          }
        })
    },
    reqTableData() {
      this.reqAllMenulist()
    },
    // 初始化表头
    initTableColum() {
      this.gridColumns = [];
      for (var item of titles) {
        let obj = {
          label: item.title,
          prop: item.key,
          width: item.width
        };
        this.gridColumns.push(obj);
      }
      for (let i = 0; i < this.gridColumns.length; i++) {
        // 渲染状态字段
        renderState(this.gridColumns[i], "menuState", this);
      }
    },
    // 新增
    newAdd() {
      this.addmodelInfo = {
        isShow: true,
        title: "新增",
        form: {}
      }
    },
    // 编辑事件
    handleEdit(index, row) {
      this.addmodelInfo = {
        isShow: true,
        title: "编辑",
        form: row
      }
    },
    // 删除请求
    reqDelete(query, url) {
      fetchPost(url, query).then(res => {
        if (res.status == '10000') {
          this.$message({
            message: '操作成功！',
            type: res.message
          })
          this.reqAllMenulist()
        } else {
          this.$message.error(res.message ? res.message : '操作失败！');
        }
      })
    },
    // 删除当前行
    handleDelete(index, item) {
      let query = { menuId: item.id }
      let url = "/hcm/menu/delete"
      let func = this.reqDelete
      let info = {
        title: `你确认要删除该条信息吗？`,
        infoccc: '删除后', infored: `该条菜单信息将会被彻底删除`
      }
      renderDialog(info, url, query, func, this)
    },
  }
};
</script>
<style lang="scss">
.addBtn {
  display: block;
  width: 100%;
  border: 1px dashed #ddd;
  margin: 0 0 25px 0;
  font-size: 14px;
}
</style>
